export default [
    {
        name: "seaweedModel",
        type: "gltfModel",
        path: "models/Seaweed.glb",
    },
    {
        name: "blueTangModel",
        type: "gltfModel",
        path: "models/BlueTang.glb",
    },
    {
        name: "butterflyFishModel",
        type: "gltfModel",
        path: "models/ButterflyFish.glb",
    },
    {
        name: "floorRocks",
        type: "gltfModel",
        path: "models/FloorRocks.glb",
    },
    {
        name: "blueTangTexture",
        type: "texture",
        path: "textures/BlueTang.webp",
        flipY: false,
    },
    {
        name: "butterflyFishTexture",
        type: "texture",
        path: "textures/ButterflyFish.webp",
        flipY: false,
    },
    {
        name: "rockTexture",
        type: "texture",
        path: "textures/RockTexture.webp",
        flipY: false,
    },
    {
        name: "planktonTexture",
        type: "texture",
        path: "textures/plankton@2x.png",
    },
];
